import { Graphics } from "pixi.js"
import { lineSegmentIntersectsCircle } from "../lib/line-segment-intersects-circle"

export function useVulnerability(
  object,
  { player, health, radius = 10, points = [], debug = false },
) {
  object.health = health
  object.lastHit = 0

  const hitBulletIds = []

  if (!points.length) points = [{ x: 0, y: 0, r: radius }]

  const largestRadius = Math.max(...points.map(({ r }) => r || radius))

  object.checkBullet = (bullet, time) => {
    if (!object.health) return
    if (hitBulletIds.includes(bullet.id)) return

    const dvx = bullet.velocity.x * time.deltaTime
    const dvy = bullet.velocity.y * time.deltaTime

    if (
      Math.abs(bullet.x - object.x) - Math.abs(dvx) > largestRadius * 2 ||
      Math.abs(bullet.y - object.y) - Math.abs(dvy) > largestRadius * 2
    )
      return

    const s = Math.sin(object.rotation)
    const c = Math.cos(object.rotation)

    if (
      points.some(({ x: ox, y: oy, r }) => {
        const rx = ox * object.width
        const ry = oy * object.height

        const x = rx * c - ry * s
        const y = rx * s + ry * c

        return lineSegmentIntersectsCircle({
          x1: bullet.x,
          y1: bullet.y,
          x2: bullet.x + dvx,
          y2: bullet.y + dvy,
          cx: object.x + x,
          cy: object.y + y,
          r: r || radius,
        })
      })
    ) {
      object.health -= bullet.damage
      hitBulletIds.push(bullet.id)
      object.lastHit = Date.now()
    }
  }

  // Debugging
  if (debug) {
    const gfx = new Graphics()

    window.Game.app.ticker.add(() => {
      gfx.clear()

      points.forEach(({ x: ox, y: oy, r }) => {
        const rx = ox * object.width
        const ry = oy * object.height
        const s = Math.sin(object.rotation)
        const c = Math.cos(object.rotation)

        const x = rx * c - ry * s
        const y = rx * s + ry * c
        gfx.circle(object.x + x, object.y + y, r || radius).stroke("#f00")
      })
    })

    window.Game.world.addChild(gfx)
  }
}
